module.exports = __webpack_public_path__ + "img/images.03eff3a8.svg";